import {
  ChangeDetectionStrategy, Component, contentChildren, Input,
} from '@angular/core'
import { CommonModule } from '@angular/common'
import { RouterOrExternalLinkDirective } from '@knorr-bremse-portals/ngx-components'
import { FooterLinkComponent } from '@knorr-bremse-portals/ngx-components/components/footer'

@Component({
  selector: 'nav[kb-footer-link-section]',
  templateUrl: './footer-link-section.component.html',
  styleUrls: ['./footer-link-section.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, RouterOrExternalLinkDirective],
})
export class FooterLinkSectionComponent {
  @Input({ required: true }) public heading!: string

  protected leftLinks = contentChildren(FooterLinkComponent)
}
